module.exports = __webpack_public_path__ + "media/images/dmc/tour-01-ba96ce17afb82b9edbab49586371a324.jpg";